import type { TaxInvoice } from "@/types";

export const taxInvoices: TaxInvoice[] = [
  {
    id: "INV-1056",
    branch: "فرع العليا",
    customer: "لطيفة الدوسري",
    phone: "0552223344",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٤٨ م",
    timestamp: "2026-09-20T21:48:00+03:00",
    payment: "card",
    pickup: "delivery",
    source: "app",
    invoiceType: "simplified",
    lines: [
      { name: "مندي لحم", quantity: 1, price: 65 },
      { name: "كبسة دجاج", quantity: 1, price: 45 },
    ],
    subtotal: 110,
    discount: 0,
    deliveryFee: 15,
    appFee: 0.8,
    vat: 16.41,
    total: 125.8,
  },
  {
    id: "INV-1054",
    branch: "فرع العليا",
    customer: "سعد الحربي",
    phone: "0551234567",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٤٢ م",
    timestamp: "2026-09-20T21:42:00+03:00",
    payment: "card",
    pickup: "car",
    source: "app",
    invoiceType: "simplified",
    lines: [
      { name: "كبسة دجاج", quantity: 2, price: 45 },
      { name: "حمص بالطحينة", quantity: 1, price: 15 },
      { name: "شاي بالنعناع", quantity: 1, price: 8 },
    ],
    subtotal: 113,
    discount: 0,
    appFee: 0.8,
    vat: 14.84,
    total: 113.8,
  },
  {
    id: "INV-1053",
    branch: "فرع النخيل",
    customer: "نورة القحطاني",
    phone: "0553219876",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٣٩ م",
    timestamp: "2026-09-20T21:39:00+03:00",
    payment: "applepay",
    pickup: "branch",
    source: "app",
    invoiceType: "simplified",
    lines: [
      { name: "برياني دجاج", quantity: 1, price: 38 },
      { name: "شاي بالنعناع", quantity: 1, price: 8 },
      { name: "لقيمات", quantity: 1, price: 14 },
    ],
    subtotal: 60,
    discount: 0,
    appFee: 0.8,
    vat: 7.93,
    total: 60.8,
  },
  {
    id: "INV-1052",
    branch: "فرع العليا",
    customer: "فهد الدوسري",
    phone: "0567891234",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٣٦ م",
    timestamp: "2026-09-20T21:36:00+03:00",
    payment: "wallet",
    pickup: "local",
    source: "app",
    invoiceType: "standard",
    lines: [
      { name: "مندي لحم", quantity: 2, price: 65 },
      { name: "كبسة دجاج", quantity: 1, price: 45 },
      { name: "ليمون بالنعناع", quantity: 2, price: 12 },
    ],
    subtotal: 199,
    discount: 10,
    appFee: 0.8,
    vat: 24.76,
    total: 189.8,
  },
  {
    id: "INV-1050",
    branch: "فرع النخيل",
    customer: "خالد الشهري",
    phone: "0534567890",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٣٠ م",
    timestamp: "2026-09-20T21:30:00+03:00",
    payment: "card",
    pickup: "branch",
    source: "app",
    invoiceType: "simplified",
    lines: [
      { name: "مندي لحم", quantity: 1, price: 65 },
      { name: "برياني دجاج", quantity: 2, price: 38 },
      { name: "سمبوسة مقرمشة", quantity: 2, price: 12 },
    ],
    subtotal: 165,
    discount: 0,
    appFee: 0.8,
    vat: 21.63,
    total: 165.8,
  },
  {
    id: "INV-1049",
    branch: "فرع العليا",
    customer: "منى الغامدي",
    phone: "0598765432",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٢٧ م",
    timestamp: "2026-09-20T21:27:00+03:00",
    payment: "applepay",
    pickup: "local",
    source: "app",
    invoiceType: "simplified",
    lines: [{ name: "برياني دجاج", quantity: 1, price: 38 }],
    subtotal: 38,
    discount: 0,
    appFee: 0.8,
    vat: 5.06,
    total: 38.8,
  },
  {
    id: "INV-1048",
    branch: "فرع الملقا",
    customer: "أحمد الزهراني",
    phone: "0551112233",
    date: "٢٠ سبتمبر ٢٠٢٦ — ٩:٢٣ م",
    timestamp: "2026-09-20T21:23:00+03:00",
    payment: "wallet",
    pickup: "car",
    source: "app",
    invoiceType: "standard",
    lines: [
      { name: "مندي لحم", quantity: 3, price: 65 },
      { name: "كبسة دجاج", quantity: 2, price: 45 },
      { name: "حمص بالطحينة", quantity: 2, price: 15 },
    ],
    subtotal: 315,
    discount: 15,
    appFee: 0.8,
    vat: 39.23,
    total: 300.8,
  },
];